import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "filter-bar segment scheme-medium-dark content" }
const _hoisted_2 = { class: "container-content" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "segment scheme-light content" }
const _hoisted_5 = { class: "container-content" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-10-10 col-10-lg-2 event-calendar-filter" }
const _hoisted_8 = { for: "eventStartDate" }
const _hoisted_9 = { for: "eventEndDate" }
const _hoisted_10 = { class: "facets" }
const _hoisted_11 = { class: "facet-reset" }
const _hoisted_12 = { class: "col-10-10 col-10-lg-8" }
const _hoisted_13 = {
  key: 0,
  class: "segment scheme-light content"
}
const _hoisted_14 = { class: "container-content" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "pagination" }
const _hoisted_17 = ["aria-live"]
const _hoisted_18 = { class: "event-calendar-item" }
const _hoisted_19 = { class: "event-calendar-title" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 0,
  class: "event-calendar-internal-icon col-2"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  src: "/resources/images/event.svg",
  width: "25",
  height: "25",
  alt: "",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "event-calendar-information" }
const _hoisted_26 = { class: "event-calendar-date" }
const _hoisted_27 = { class: "event-calendar-day-and-location" }
const _hoisted_28 = { class: "event-calendar-weekday d-flex" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-clock",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_30 = { class: "event-calendar-location d-flex" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-location",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = {
  key: 1,
  class: "segment scheme-light content"
}
const _hoisted_36 = { class: "container-content" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "pagination" }

import { inject, ref, Ref } from 'vue';
import FacetsContainer from './components/FacetsContainer.vue';
import PaginationBar from './components/PaginationBar.vue';
import SkipLink from './components/SkipLink.vue';
import axios, { AxiosResponse } from 'axios';
import {
    getFacetsByFieldName,
    RequestUrl,
    SolrArguments,
    SolrResponseData, SolrEventDocument, SolrFacet
} from '../modules/solr'; // eslint-disable-line import/no-relative-parent-imports
import SearchBar from './components/SearchBar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EventCalendar',
  props: {
    endpoint: {},
    pluginNamespace: {},
    arguments: {}
  },
  setup(__props: any) {

const props = __props;



const i18n = inject('i18n') as { [key: string]: string };
const defaultArguments: SolrArguments = {
    filter: ['type:tx_news_domain_model_news', 'newsIsEvent:true'], // fallback
    page: '1', // required
    perPage: '0', // placeholder, see setPerPage()
    q: '*', // required
    sort: 'newsStarttimeStamp asc' // fallback
};

const eventStartDate = ref<Date|null>(null);
const eventEndDate = ref<Date|null>(null);

const initialArguments: SolrArguments = { ...defaultArguments, ...JSON.parse(props.arguments) as SolrArguments };
const initialUrl = RequestUrl.buildFromArguments(props.endpoint, props.pluginNamespace, initialArguments);

let currentUrl = new RequestUrl(initialUrl);

const listUpdateStatus = ref(false);
const loading = ref(true);

const events: Ref<SolrEventDocument[]> = ref([]);
const eventList = ref<HTMLElement | null>(null);

const currentPageNumber = ref(parseInt(initialArguments.page));
const totalNumberOfPages = ref(1);
const currentSorting = ref(initialArguments.sort);
const currentSearchTerm = ref(initialArguments.q);
const currentSearchDate = ref<string|null>(null);
const facets = ref([] as SolrFacet[]);

function formattedStartDate (event: SolrEventDocument): string {
    const date = new Date(event.newsStarttime);
    const lang = document.documentElement.lang;

    return (new Intl.DateTimeFormat(lang === 'de' ? 'de-AT' : 'en-US', {
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC'
    })).format(date);
}

function formattedStartDay (event: SolrEventDocument): string {
    const date = new Date(event.newsStarttime);
    const lang = document.documentElement.lang;

    return (new Intl.DateTimeFormat(lang === 'de' ? 'de-AT' : 'en-US', {
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric',
        timeZone: 'UTC'
    })).format(date);
}

function loadEventsAfterPageSelect (page: number): void {
    currentPageNumber.value = page;
    loadEvents();
}

function loadEventsAfterSearchTermGiven (searchTerm: string): void {
    currentSearchTerm.value = searchTerm;
    // Reset page number
    currentPageNumber.value = 1;
    loadEvents();
}

function loadEventsAfterDatePickerOnChange (): void {
    if (eventStartDate.value && eventEndDate.value) {
        currentSearchDate.value = 'newsStarttime:[' + new Date(eventStartDate.value).toISOString() + ' TO ' + new Date(eventEndDate.value).toISOString() + ']';
    } else if (eventStartDate.value) {
        currentSearchDate.value = 'newsStarttime:[' + new Date(eventStartDate.value).toISOString() + ' TO *]';
    } else if (eventEndDate.value) {
        currentSearchDate.value = 'newsStarttime:[* TO ' + new Date(eventEndDate.value).toISOString() + ']';
    }
    // Reset page number
    currentPageNumber.value = 1;
    loadEvents();
}

function loadEventsAfterFacetChange (name: string, value: string, type: string): void {
    switch (type) {
        case 'add':
            currentUrl.addFilterParameter(`${name}:${value}`);
            break;
        case 'remove':
            currentUrl.removeFilterParameter(`${name}:${value}`);
            break;
        case 'set':
            currentUrl.removeFilter(name);
            currentUrl.addFilterParameter(`${name}:${value}`);
            break;
        default:
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            console.trace(`Invalid change type '${type}' (facet change).`);
    }
    // Reset page number
    currentPageNumber.value = 1;
    loadEvents();
}

function loadEvents (): void {
    loading.value = true;
    const url = new RequestUrl(currentUrl);

    url.removeFilter('newsStarttime');
    if (currentSearchDate.value !== null) {
        url.addFilterParameter(currentSearchDate.value);
    } else {
        url.addFilterParameter('newsStarttime:[NOW TO *]');
    }

    if (currentSearchTerm.value.trim() === '') {
        currentSearchTerm.value = '*';
    }

    url.setQuery(currentSearchTerm.value);
    url.setSorting(currentSorting.value);
    url.setPage(currentPageNumber.value);

    axios
        .get(url.toString())
        .then((response: AxiosResponse<SolrResponseData>) => {
            events.value = response.data.documents as Array<SolrEventDocument>;
            currentPageNumber.value = response.data.currentPage;
            totalNumberOfPages.value = response.data.lastPage;
            facets.value = getFacetsByFieldName(response.data.facets, ['newsEventIsIntern']);

            listUpdateStatus.value = true;
            eventList.value?.focus();
            eventList.value?.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            });

            setTimeout(() => {
                listUpdateStatus.value = false;
            }, 2000);

            return undefined;
        })
        .catch((reason: string) =>
            console.trace('Loading of events failed:' + reason)
        )
        .finally(() => {
            loading.value = false;
        });

    currentUrl = url;
}

function resetFilter (): void {
    currentUrl = new RequestUrl(RequestUrl.buildFromArguments(props.endpoint, props.pluginNamespace, initialArguments));

    currentSearchDate.value = null;
    eventStartDate.value = null;
    eventEndDate.value = null;
    loadEvents();
}

const url = new RequestUrl(currentUrl);
axios.get(url.toString())
    .then((response: AxiosResponse<SolrResponseData>) => {
        events.value = response.data.documents as Array<SolrEventDocument>;
        currentPageNumber.value = response.data.currentPage;
        totalNumberOfPages.value = response.data.lastPage;
        facets.value = getFacetsByFieldName(response.data.facets, ['newsEventIsIntern']);
        return undefined;
    })
    .catch(() => console.trace('Initial loading of events failed.'))
    .finally(() => {
        loading.value = false;
    });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(SearchBar, {
            "search-term": "",
            onSearch: loadEventsAfterSearchTermGiven
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(i18n).dateFrom), 1 /* TEXT */),
              _withDirectives(_createElementVNode("input", {
                id: "eventStartDate",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((eventStartDate).value = $event)),
                type: "date",
                name: "eventStartDate",
                onChange: loadEventsAfterDatePickerOnChange
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelText, eventStartDate.value]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(i18n).dateTo), 1 /* TEXT */),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((eventEndDate).value = $event)),
                type: "date",
                name: "eventEndDate",
                onChange: loadEventsAfterDatePickerOnChange
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelText, eventEndDate.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(FacetsContainer, {
                facets: facets.value,
                onChange: loadEventsAfterFacetChange
              }, null, 8 /* PROPS */, ["facets"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "button button-reset",
                onClick: resetFilter
              }, _toDisplayString(_unref(i18n).resetFilter), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (totalNumberOfPages.value > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(SkipLink, { to: "#event-calendar-cards" }),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(PaginationBar, {
                          current: currentPageNumber.value,
                          total: totalNumberOfPages.value,
                          onSelect: loadEventsAfterPageSelect
                        }, null, 8 /* PROPS */, ["current", "total"])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("ul", {
              id: "event-calendar-cards",
              ref_key: "eventList",
              ref: eventList,
              class: "event-calendar inner-row",
              "aria-live": listUpdateStatus.value ? 'assertive' : 'off',
              tabindex: "-1"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.value, (document) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: document.id,
                  class: "box box-grid box-grid-top-closed col-2-2 col-2-md-1"
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", {
                          class: _normalizeClass(document.newsEventIsIntern ? 'col-9' : 'col--12')
                        }, [
                          _createElementVNode("a", {
                            href: document.url
                          }, _toDisplayString(document.title), 9 /* TEXT, PROPS */, _hoisted_21)
                        ], 2 /* CLASS */),
                        (document.newsEventIsIntern)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, _toDisplayString(formattedStartDate(document)), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createTextVNode(" " + _toDisplayString(formattedStartDay(document)) + " " + _toDisplayString(_unref(i18n).hour), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          (document.newsEventType === 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_unref(i18n).eventTypeVirtual), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (document.newsEventType === 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_unref(i18n).eventTypeHybrid), 1 /* TEXT */))
                            : (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(document.newsEventCountry) + ", " + _toDisplayString(document.newsEventLocation), 1 /* TEXT */))
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 8 /* PROPS */, _hoisted_17),
            (totalNumberOfPages.value > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(PaginationBar, {
                          current: currentPageNumber.value,
                          total: totalNumberOfPages.value,
                          onSelect: loadEventsAfterPageSelect
                        }, null, 8 /* PROPS */, ["current", "total"])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})